const PhotosService = {

  parsePhoto: function(response) {
    if (!response) return null;

    return {
      id: response.id,
      createdAt: undefined,
      defaultImage: response.default_image,
      originalImage: response.original_image,
      squareTemplateHref: response.square_template_href,
      _links: response._links,
      _forms: response._forms
    };
  }

};

export default PhotosService;



// WEBPACK FOOTER //
// ./src/api/services/photosService.js